(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fingies-product-bg"] && !Shopify.designMode) return;
  try {
    (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const io =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const video = entry.target;
                if (entry.isIntersecting && !reduce.matches) video.play().catch(() => {});
                else video.pause();
              });
            },
            { rootMargin: '120px' }
          )
        : null;

    const scan = (root = document) => {
      root.querySelectorAll('video.fp-bg__video:not([data-fp-watched])').forEach((video) => {
        video.dataset.fpWatched = '';
        video.muted = true;
        if (io) io.observe(video);
        else if (!reduce.matches) video.play().catch(() => {});
      });
    };

    window.fingiesScanBackgrounds = scan;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
    else scan();
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
